module.exports = __webpack_public_path__ + "img/kpz.c34d85f4.png";